import { useQuery } from '@tanstack/react-query';
import useFetch from './use-fetch';
function useServiceFile({ config, path = '', queryOptions = { retry: false } }) {
    const fetchWrapper = useFetch(config);
    return useQuery(Object.assign({ queryKey: [config.hosts.serviceFile], queryFn: () => {
            return fetchWrapper(path, { method: 'GET' }, config.hosts.serviceFile, false);
        } }, queryOptions));
}
export default useServiceFile;
//# sourceMappingURL=use-service-file.js.map